// @flow

import * as React from 'react'
import { DataGrid, DataGridDuck } from 'react-redux-components'
import { connect, type Connector } from 'react-redux'
import { Dimmer } from 'semantic-ui-react'

import authenticatedRequest from '../store/authenticated-request'
import VisitsReportToolbar from './visits-details-report-toolbar'
import { getSummaryData } from '../store/reports'

import type { CardSummary } from '../store/campaigns'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  currentCampaign: string,
  showWeb: boolean,
  showPhone: boolean,
  showF2F: boolean,
  startDate: moment$Moment,
  endDate: moment$Moment,
  dataUrl: string,
  summary: CardSummary | Object,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let dataUrl =
    '/api/reports/' +
    state.allowedCampaigns.currentCampaign +
    '/doctor_list/' +
    state.reports.ui.startDate.format('YYYYMMDD') +
    '/' +
    state.reports.ui.endDate.format('YYYYMMDD') +
    '/' +
    state.reports.ui.showWeb.toString() +
    '/' +
    state.reports.ui.showF2F.toString() +
    '/' +
    state.reports.ui.showPhone.toString()

  return {
    currentCampaign: state.allowedCampaigns.currentCampaign,
    showWeb: state.reports.ui.showWeb,
    showPhone: state.reports.ui.showPhone,
    showF2F: state.reports.ui.showF2F,
    startDate: state.reports.ui.startDate,
    endDate: state.reports.ui.endDate,
    dataUrl,
    summary: state.reports.ui.summary,
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps

class VisitsDetailsReport extends React.Component<Props> {
  static defaultProps = {}

  componentWillUpdate(nextProps) {
    if (nextProps.currentCampaign !== '' && nextProps.dataUrl !== this.props.dataUrl) {
      this.props.dispatch(DataGridDuck.creators.resetDatagrid('visitsDetailsReportGrid'))
      this.props.dispatch(
        getSummaryData(
          nextProps.currentCampaign,
          nextProps.startDate.format('YYYYMMDD'),
          nextProps.endDate.format('YYYYMMDD'),
          nextProps.showWeb.toString(),
          nextProps.showF2F.toString(),
          nextProps.showPhone.toString()
        )
      )
    }
  }

  render() {
    let columns = [
      { key: 'id_medico', name: 'ID Medico', resizable: true, sortable: true, width: 100 },
      { key: 'nome', name: 'Nome', resizable: true, sortable: true },
      { key: 'cognome', name: 'Cognome', resizable: true, sortable: true },
      { key: 'area', name: 'Area', resizable: true, sortable: true, width: 120 },
      { key: 'provincia', name: 'Provincia', resizable: true, sortable: true, width: 120 },
      { key: 'totVisite', name: 'Totale Visite', resizable: true, sortable: true, width: 100 },
      { key: 'lastVisitDate', name: 'Data Ultima V.', resizable: false, sortable: true, width: 140 },
      { key: 'lastChannel', name: 'Canale Ultima V.', resizable: true, sortable: true, width: 140 },
      { key: 'lastCallExp', name: 'Ultima Call Exp.', resizable: true, sortable: true, width: 140 },
    ]

    return (
      <Dimmer.Dimmable dimmed={this.props.currentCampaign === ''} className="main-container">
        <Dimmer active={this.props.currentCampaign === ''} inverted style={{ zIndex: 700 }} />
        {this.props.currentCampaign !== '' && (
          <div style={{ height: '100vh', marginTop: '-2ex', display: 'flex', flexDirection: 'column' }}>
            <DataGrid
              disabled={true}
              model="visitsDetailsReportGrid"
              request={authenticatedRequest}
              columns={columns}
              dataUrl={this.props.dataUrl}
              initialPageSize={40}
              toolbarContent={<VisitsReportToolbar />}
            />
            <div style={{ height: '2.5rem', lineHeight: '2.5rem' }}>
              <div className="ui fluid steps" style={{ height: '4rem' }}>
                <div className="step" style={{ padding: '.4rem' }}>
                  <i aria-hidden="true" className="dashboard icon" />
                  <div className="content">
                    <div className="title">Totale</div>
                    <div className="description">{`Visite: ${this.props.summary.total.visits} - Rate: ${this.props
                      .summary.total.rate}`}</div>
                  </div>
                </div>
                {this.props.showWeb && (
                  <div className="step" style={{ padding: '.4rem' }}>
                    <i aria-hidden="true" className="cloud icon" />
                    <div className="content">
                      <div className="title">Canale WEB</div>
                      <div className="description">{`Visite: ${this.props.summary.WEB.visits} - Rate: ${this.props
                        .summary.WEB.rate}`}</div>
                    </div>
                  </div>
                )}
                {this.props.showF2F && (
                  <div className="step" style={{ padding: '.4rem' }}>
                    <i aria-hidden="true" className="male icon" />
                    <div className="content">
                      <div className="title">Canale F2F</div>
                      <div className="description">{`Visite: ${this.props.summary.F2F.visits} - Rate: ${this.props
                        .summary.F2F.rate}`}</div>
                    </div>
                  </div>
                )}
                {this.props.showPhone && (
                  <div className="step" style={{ padding: '.4rem' }}>
                    <i aria-hidden="true" className="phone icon" />
                    <div className="content">
                      <div className="title">Canale PHONE</div>
                      <div className="description">{`Visite: ${this.props.summary.PHONE.visits} - Rate: ${this.props
                        .summary.PHONE.rate}`}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Dimmer.Dimmable>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(VisitsDetailsReport)



// WEBPACK FOOTER //
// ./src/reports/visits-details-report.js